export const SAVE_SETTINGS = 'SAVE_SETTINGS'
export const GOOGLE_APIS_LOADED = 'GOOGLE_APIS_LOADED'
